import SET_LOCALE from './types';
export default {
  [SET_LOCALE](state, payload) {
    var currentState = state;
    currentState.currentLocale = payload;
  }
};